const CryptoJS = require('crypto-js');
 
export class AesUtil {
    constructor() {
        this.key = '498aa575016fedc251b677315eb';
    }
 
    encrypt(plainText) {
        return CryptoJS.AES.encrypt(plainText, this.key).toString();
    }
 
    decrypt(encryptedText) {
        const bytes = CryptoJS.AES.decrypt(encryptedText, this.key);
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}
 



// Example usage:
// const aes = new AesUtil();
// console.log(aes.encrypt('123123'));
// console.log(aes.decrypt('...'));  // Use a valid encrypted string